/** PipeKit engineering-core — public API boundary.
 *  Everything a UI/browser bundle or Node test needs to import. */
export * from "./units.js";
export * from "./datasets.js";
export * from "./schemas.js";
export * from "./engine.js";
export * from "./guard.js";

export const coreVersion = "3.0.0";